var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mobile-menu"
  }, [_c('div', {
    staticClass: "mobile-menu-item-container",
    on: {
      "click": function ($event) {
        return _vm.$emit('closeMenu');
      }
    }
  }, _vm._l(_vm.navigationMenuItems, function (menuItem) {
    return _c('menu-item', {
      key: menuItem.label,
      attrs: {
        "label": menuItem[_vm.currentLanguage].label,
        "route": menuItem.route,
        "params": {
          slug: menuItem[_vm.currentLanguage].slug
        }
      }
    });
  }), 1), _vm._m(0), _c('div', {
    staticClass: "mobile-menu-footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_vm._m(1), _c('div', {
    staticClass: "right-column"
  }, [_c('div', {
    staticClass: "caps-medium",
    on: {
      "click": function ($event) {
        return _vm.openPopup('ARRIVAL');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.arrival')))]), _c('div', {
    staticClass: "caps-medium",
    on: {
      "click": function ($event) {
        return _vm.openPopup('MEDIA');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.media')))]), _c('div', {
    staticClass: "caps-medium",
    on: {
      "click": function ($event) {
        return _vm.openPopup('NEWSLETTER');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.newsletter')))]), _c('div', {
    staticClass: "caps-medium",
    on: {
      "click": function ($event) {
        return _vm.openPopup('JOBS');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.jobs')))]), _c('div', {
    staticClass: "caps-medium",
    on: {
      "click": function ($event) {
        return _vm.openPopup('IMPRESSUM');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.imprint')))]), _c('div', {
    staticClass: "caps-medium",
    on: {
      "click": function ($event) {
        return _vm.openPopup('TERMS');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.terms')))])])]), _c('language-picker')], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "social-media-divider"
  }, [_c('div', {
    staticClass: "plus-icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/plus-black.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "line"
  }), _c('a', {
    staticClass: "linked-in-icon-container",
    attrs: {
      "href": "https://www.linkedin.com/company/swiss-engineers-united"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/linkedin-icon.svg"),
      "alt": ""
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left-column"
  }, [_c('div', {
    staticClass: "info-row"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/location-icon.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "caption mobile-caption"
  }, [_vm._v("Churerstrasse 54 CH-8808 Pfäffikon SZ")])]), _c('div', {
    staticClass: "info-row"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/call-icon.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "caption mobile-caption"
  }, [_vm._v("+41 (0)58 521 19 00")])]), _c('div', {
    staticClass: "info-row"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/world-icon-2.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "caption mobile-caption"
  }, [_vm._v("www.seu.ch ")])]), _c('div', {
    staticClass: "info-row"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/mail-icon-2.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "caption mobile-caption"
  }, [_vm._v("info@seu.ch ")])])]);

}]

export { render, staticRenderFns }